// src/admin/layout/AdminLayout.tsx
import React, { useState } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AdminSidebar from "../Components/AdminSidebar";
import AdminTopbar from "../Components/AdminTopbar";

type Props = {
  children: React.ReactNode;
};

const AdminLayout: React.FC<Props> = ({ children }) => {
  const sidebarWidth = 260;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleToggleSidebar = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    setMobileOpen(false);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <AdminSidebar
        width={sidebarWidth}
        mobileOpen={mobileOpen}
        onClose={handleCloseSidebar}
      />
      <Box
        sx={{
          flex: 1,
          ml: { xs: 0 },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AdminTopbar onMenuClick={handleToggleSidebar} />
        <Box component="main" sx={{ p: { xs: 2, md: 3 }, flex: 1 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
